import { Fragment } from "react";
import { SKTToggle } from "./SKTToggle";
import { css } from "./SKT";
import { BsInfoCircle } from "react-icons/bs";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { v4 } from "uuid";

const SKTToolTipIcon = ({ tooltip, id }) => {
  if (!tooltip) return <></>;
  return (
    <>
      <span style={{ width: 10 }}>&nbsp;</span>
      <BsInfoCircle data-tooltip-id={id} />
    </>
  );
};

const SKTToolTip = ({ tooltip, id }) => {
  if (!tooltip) return <></>;
  return <ReactTooltip id={id} place="bottom" content={tooltip} />;
};

export const SKTBaseComponent = ({
  id,
  label,
  labelAfter,
  childrenInline,
  children,
  data,
  childrenToLeft,
  tooltip,
  tooltipIcon,
}) => {
  const tooltipID = "tooltip-" + v4();

  if (labelAfter) {
    return (
      <div className={css("form-group row")}>
        <div className={css("col-md-4")}></div>
        <div className={css("col-md-1")}>
          {children}
          <p className={css("control-label")}>&nbsp;</p>
        </div>
        <div className={css("col-md-7")}>
          <label className={css("control-label")} for={id}>
            {label}
            <SKTToolTipIcon id={tooltipID} tooltip={tooltip} />
          </label>
        </div>
        <SKTToolTip id={tooltipID} tooltip={tooltip} />
      </div>
    );
  }

  const isValid = data && data.isValid(id);
  const feedback = data && data.feedback(id);

  const childrenContainerKlass = css(
    "col-md-8" + (childrenToLeft ? "" : " skt-move-to-right")
  );
  const childrenContainer = childrenInline ? (
    <Fragment>{children}</Fragment>
  ) : (
    <div className={childrenContainerKlass}>
      <div className={css("skt-invalid-feedback")}>
        <SKTToggle when={!isValid}>{feedback}</SKTToggle>
        &nbsp;
      </div>
      {children}
    </div>
  );

  const klassNames = css("form-group row");

  return (
    <div className={klassNames}>
      <label className={css("col-md-4 control-label")} for={id}>
        {label}
        <SKTToolTipIcon id={tooltipID} tooltip={tooltip} />
      </label>
      {childrenContainer}
      <SKTToolTip id={tooltipID} tooltip={tooltip} />
    </div>
  );
};
